import React, { useState } from 'react'
import { Modal } from 'react-bootstrap';
import '../../assets/css/IntroModal.scss';
const IntroModal = ({ handleClose, show, introModalDetails = { title: "" } }) => {
  const [isEntering, setIsEntering] = useState(false);

  const handleDismiss = () => {
    handleClose();
  }

  const handleEnterMetaverse = () => {
    setIsEntering(true);
    setTimeout(() => {
      handleClose();
    }, 1500);
  }

  return (
    <>
      <Modal show={show} centered onHide={handleDismiss} size='lg' className="introModal">
        <Modal.Body className="introModal-body">
          <div className="introModal-content">

            <div className="introModal-background">
              <img src="https://simulanislegacy.blob.core.windows.net/creator/uno/production/resources/1cb0fef9-e6d1-4095-b674-98e8aee658e5/IMAGE/d04a5b19-b77c-4482-b142-154b434edc79.jpg" alt="Project" />
              <div className="introModal-blur"></div>
            </div>


            <div className="introModal-main">
              <div className="introModal-text">
                <h2 className="introModal-title">
                  Welcome to {introModalDetails.title}
                </h2>
                <p className="introModal-description">
                  Experience immersive 360° content like never before. Our platform lets you view it in 360 dimensions,
                  bringing your projects to life with interactive hotspots, rich media, and cutting-edge virtual experiences.
                </p>
              </div>

              <div className="introModal-button-container">
                <button
                  className={`introModal-button ${isEntering ? 'loading' : ''}`}
                  onClick={handleEnterMetaverse}
                  disabled={isEntering}
                >
                  {isEntering ? (
                    <span className="button-loading">
                      <span className="spinner"></span>
                      Entering...
                    </span>
                  ) : (
                    'Enter'
                  )}
                </button>
              </div>
            </div>
          </div>
        </Modal.Body>
      </Modal>
      
     
    </>
  )
}

export default IntroModal